export default class Accordion {
    constructor(accordion, options) {
        this.accordion = accordion;
        this.lastClicked = null;
        this.accordionContent = [];

        this.options = {
            scrollTop: true,
            scrollTopBehavior: 'smooth',
            scrollTopBlock: 'end',
            scrollTopItem: 'prev', // 'prev' or 'current'
            ...options,
        }

        this.initAccordion();
    }

    initAccordion() {
        Array
            .from(this.accordion.children)
            .map(
                (item, index) => {
                    if (index % 2 === 0) {
                        this.accordionContent.push({title: item});

                        item.addEventListener('click', this.onAccordionTitleClick.bind(this));
                    }
                    if (index % 2 === 1) {
                        this.accordionContent[this.accordionContent.length - 1].content = item;
                    }
                }
            );

        window.document.addEventListener('scroll', () => {
            if (!this.lastClicked) {
                return;
            }

            let selectedIndex = null;
            this.accordionContent.find((obj, index) => {
                if (obj.title === this.lastClicked) {
                    selectedIndex = index;
                }
            });

            const nextTitle = this.accordionContent[
                selectedIndex < this.accordionContent.length - 1 ? selectedIndex + 1 : selectedIndex
            ].title;

            if (nextTitle.getBoundingClientRect().top < nextTitle.clientHeight) {
                this.lastClicked.classList.remove('is-open');
            } else {
                this.lastClicked.classList.add('is-open');
            }
        });
    }

    onAccordionTitleClick(e) {
        if (this.lastClicked === e.target) {
            this.hideAllAccordionItems();
            this.lastClicked = null;
            return;
        }
        this.hideAllAccordionItems();

        const foundItem = this.accordionContent.find(obj => obj.title === e.target);
        setTimeout(() => {
            if (!foundItem) {
                return;
            }
            foundItem.title.classList.add('is-open');
            foundItem.content.classList.add('is-visible');

            let selectedIndex = null;
            this.accordionContent.find((obj, index) => {
                if (obj.title === foundItem.title) {
                    selectedIndex = index;
                }
            });

            const prevContent = this.accordionContent[
                selectedIndex < this.accordionContent.length - 1 ? selectedIndex + 1 : selectedIndex
                ].content;
            if (this.options.scrollTop) {
                const el = this.options.scrollTopItem === 'prev' ? prevContent : foundItem.content;
                el.scrollIntoView({ behavior: this.options.scrollTopBehavior, block: this.options.scrollTopBlock });
            }
        }, 700);

        this.lastClicked = e.target;
    }

    hideAllAccordionItems() {
        this.accordionContent.forEach(item => {
            item.title.classList.add('is-blocked');
            item.title.classList.remove('is-open');
            item.content.classList.remove('is-visible');
        })

        setTimeout(() => {
            this.unblockAllAccordionItems();
        }, 700);
    }

    unblockAllAccordionItems() {
        this.accordionContent.forEach(item => {
            item.title.classList.remove('is-blocked');
        });
    }
}
